export default __webpack_public_path__ + "static/media/01_C.4586dea3.png";